export type QuestionHtmlTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p';

// Only heading presets are mapped here. Paragraph/body presets intentionally
// fall through to the `fallback` argument so that the question tag remains a
// real heading (h3 by default) rather than a `<p>` for SEO/a11y reasons.
const fontStyleToHtmlTag: Record<string, QuestionHtmlTag> = {
  Title: 'h1',
  'Page-title': 'h2',
  'Heading-XL': 'h3',
  'Heading-L': 'h4',
  'Heading-M': 'h5',
  'Heading-S': 'h6',
  'Heading-XS': 'h6',
  // Wix Studio (editor3) CSS variable names
  'wst-heading-1-font': 'h1',
  'wst-heading-2-font': 'h2',
  'wst-heading-3-font': 'h3',
  'wst-heading-4-font': 'h4',
  'wst-heading-5-font': 'h5',
  'wst-heading-6-font': 'h6',
};

const isQuestionHtmlTag = (value: string | undefined): value is QuestionHtmlTag =>
  value === 'h1' ||
  value === 'h2' ||
  value === 'h3' ||
  value === 'h4' ||
  value === 'h5' ||
  value === 'h6' ||
  value === 'p';

export const getHtmlTagFromPreset = (
  htmlTag: string | undefined,
  presetOrCssVar: string | undefined,
  fallback: QuestionHtmlTag,
): QuestionHtmlTag => {
  if (isQuestionHtmlTag(htmlTag)) {
    return htmlTag;
  }
  return fontStyleToHtmlTag[presetOrCssVar ?? ''] ?? fallback;
};
